import ReactDOM from "react-dom";
import React, { useState } from 'react'
import langData from '../locales/langData.json'
import PartnerForm from '../components/Forms/PartnertForm'
import arrow from '../assets/images/right-arrow.webp'
import partnergb from '../assets/images/partner-gp.webp'
import SEO from '../components/SEO'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import ClientLogoMarquee from '../components/ClientLogoMarquee'


const Partners = ({ language }) => {
    const partner = langData[language].partner;
    const clientlogos = langData[language].clientlogo;
    const [showModal, setShowModal] = useState(false);


    return (
        <>
            <SEO
                title="Partner with CaptainX | Shape the Future of Sports"
                titleAr="شراكة مع كابتن اكس | شكّل مستقبل الرياضة"
                description="Invest in the future of sport with CaptainX. Drive growth, expand global reach, and align with Saudi Vision 2030's mission for sporting excellence."
                descriptionAr="استثمر في مستقبل الرياضة. ساهم في نموها، ووسّع نطاق وصولها العالمي، وتوافق مع رؤية السعودية 2030 للتميز الرياضي."
                path="/partners"
                language={language}
            />
            {showModal &&
                ReactDOM.createPortal(
                    <PartnerForm onClose={() => setShowModal(false)} language={language}/>,
                    document.body
                )
            }

            <section className="cta-partner py-5">
                <div className="container">
                    <div className="cen-sec-con">
                        <center>
                            <h2
                                className="sec-title block-view partner-title mt-5"
                                dangerouslySetInnerHTML={{ __html: partner.title }}
                            ></h2>

                            <p
                                className="sec-p block-view"
                                dangerouslySetInnerHTML={{ __html: partner.desc }}
                            ></p>




                            <button
                                className={`explore-btn cta-btn my-4 gap-3 block-view ${language === "ar" ? "ar-padding" : "en-padding"
                                    }`}
                                onClick={() => setShowModal(true)}
                            > {partner.btn}

                                <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                            </button>

                        </center>
                    </div>

                </div>
            </section>

            <section className='card-img-lap'>
                <div className="container">
                    <h6 className='sec-top-titl py-3'>{partner.cardlaptitle}</h6>
                    <div className="row card-lap-con">
                        {partner.cardlap.map((card, index) =>
                            <div className="col-md-4 mb-4">
                                <div className="card-lap" key={index}>
                                    <div className="lpa-con">
                                        <h2>{card.title}</h2>
                                        <p>{card.desc}</p>
                                    </div>
                                    <center>
                                        <LazyLoadImage src={card.img} alt="cardlap" className='img-fluid' />
                                    </center>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <section className='sportx-sec'>
                <div className="container">
                    <div className="row py-5">
                        <div className="col-md-6">
                            <h6 className='sectoptitl text-white'>{partner.typetoptitle}</h6>
                            <h2 className='text-white'>{partner.typetitle}</h2>
                            <p className='sec-p'>
                                {partner.typedesc}
                            </p>
                        </div>
                        <div className="col-md-6"></div>
                    </div>
                    <div className="row">
                        {partner.types.map((card, index) =>
                            <div className="col-md-3 mb-4 card-sportx">
                                <div className="sportx-box" key={index}>
                                    <LazyLoadImage src={card.img} alt="wbrain" className='imgfluid pb-1' />
                                    <h4 className='pb-3'>{card.title}</h4>
                                    <p>{card.desc}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
            <section className='partner-new'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <h2 className='sec-title'>{partner.partnerstratgiesTitle}</h2>
                            <p className='sec-p'>
                                {partner.partnerstratgiesDesc}
                            </p>
                        </div>
                        <div className="col-md-6">
                            <LazyLoadImage src={partnergb} alt="partner" className='img-fluid' />
                        </div>
                    </div>
                </div>
            </section>
            <section>



                <center>
                    <h5 className="second-cen-text pt-3">{partner.morequee}</h5>
                    <h2 className="sec-title">{partner.partnermarquee}</h2>
                    <ClientLogoMarquee logos={clientlogos} language={language} />

                </center>

            </section>

            {/* CTA */}
            <section className='cta'>
                <div className="container">
                    <div className="cen-sec-con">

                        <center>
                            <h2
                                className='sec-title block-view'
                                dangerouslySetInnerHTML={{ __html: partner.ctatitle }}
                            ></h2>
                            <p
                                className="sec-p block-view"
                                dangerouslySetInnerHTML={{ __html: partner.ctadesc }}
                            ></p>

                            <button
                                className={`explore-btn cta-btn my-4 py-2 gap-3 block-view ${language === "ar" ? "ar-padding" : "en-padding"
                                    }`}
                                onClick={() => setShowModal(true)}
                            >  {partner.ctabtn}

                                <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                            </button>

                        </center>
                    </div>
                </div>
            </section>
        </>

    )
}

export default Partners